import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';

export type SelectedCaseMode = 'dashboard' | 'start_case_param';

export const notifySelectedCase = async (
  caseType: string,
  userRole?: string,
  mode: SelectedCaseMode = 'dashboard',
): Promise<void> => {
  try {
    const prefix = getStaffScopedApiPrefix(userRole);
    await client.post(`${prefix}/cases/selected/${caseType}`, {}, {
      params: { mode },
    });
  } catch (error) {
    console.warn('Failed to notify selected case:', error);
  }
};
